module.exports = __webpack_public_path__ + "assets/smart-asset-twitter-icon.4396f8e3.svg";